/* eslint-disable */

<template>
  <div>
    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row" :class="{ 'cursor-drag': draggingCard === true }">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-4">
            <h3 class="font-bold mb-4">Controls</h3>
            <vue-draggable-container id="wordBank" class="wordBank">
              <h5 class="dragBlock font-semibold cursor-pointer">nsrt</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">iita</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">nist</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">inis</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">snmA</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">trat</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">imdA</h5>
              <h5 class="dragBlock font-semibold cursor-pointer">rota</h5>
            </vue-draggable-container>
          </vx-card>
          <vx-card class="" title="Python Script">
            <h3 class="mb-4">#!/usr/bin/python<br />s = "Administrator</h3>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <vx-card class="mb-base">
            <div class="fourth-sim pt-0">
              <div class="vx-row mb-4">
                <div class="vx-col w-1/4 flex items-center">
                  <h2 class="font-bold">Code Segment</h2>
                </div>
                <div class="vx-col w-1/4 flex items-center">
                  <h2 class="font-bold">First Output Line</h2>
                </div>
                <div class="vx-col w-1/4 flex items-center">
                  <h2 class="font-bold">Second Output Line</h2>
                </div>
                <div class="vx-col w-1/4 flex items-center">
                  <h2 class="font-bold">Third Output Line</h2>
                </div>
              </div>

              <div class="vx-row border-white border-2 border-solid rounded p-4 my-2">
                <div class="vx-col w-1/4 flex items-center">
                  <h1 class="font-semibold">s[4 : 8]</h1>
                </div>
                <div class="vx-col w-1/4">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input1" />
                </div>
                <div class="vx-col w-1/4">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input2" />
                </div>
                <div class="vx-col w-1/4">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input3" />
                </div>
              </div>

              <div class="vx-row border-white border-2 border-solid rounded p-4 my-2">
                <div class="vx-col w-1/4 flex items-center">
                  <h1 class="font-semibold">s[4 : 12 : 2]</h1>
                </div>
                <div class="vx-col w-1/4">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input4" />
                </div>
                <div class="vx-col w-1/4">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input5" />
                </div>
                <div class="vx-col w-1/4">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input6" />
                </div>
              </div>

              <div class="vx-row border-white border-2 border-solid rounded p-4 my-2">
                <div class="vx-col w-1/4 flex items-center">
                  <h1 class="font-semibold">s[3 : : -1]</h1>
                </div>
                <div class="vx-col w-1/4">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input7" />
                </div>
                <div class="vx-col w-1/4">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input8" />
                </div>
                <div class="vx-col w-1/4">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input9" />
                </div>
              </div>

              <div class="vx-row border-white border-2 border-solid rounded p-4 my-2">
                <div class="vx-col w-1/4 flex items-center">
                  <h1 class="font-semibold">s[-7 : -2]</h1>
                </div>
                <div class="vx-col w-1/4">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input10" />
                </div>
                <div class="vx-col w-1/4">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input11" />
                </div>
                <div class="vx-col w-1/4">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input12" />
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Prism from 'vue-prism-component';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,
      //last_drag_error: false,

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard',
      },
    };
  },
  methods: {
    startedDrag(x) {
      x.data.source.className += ' currently-dragging-standard';
      this.draggingCard = true;
    },
    stoppedDrag() {
      this.draggingCard = false;
    },
    sort(x) {
      const overContainer = x.data.dragEvent.data.overContainer;
      const sourceContainer = x.data.dragEvent.data.sourceContainer;
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          //this.drag_error()
          x.cancel();
        }
      }
    },
    markSimulation() {
      let totalScore = 0;

      if (document.getElementById('input1').textContent === 'nsrt') {
        totalScore++;
        document.getElementById('input1').style.borderColor = '#28C76F';
        document.getElementById('input1').style.backgroundColor = '#28C76F';
      } else {
        document.getElementById('input1').style.borderColor = '#fd4445';
        document.getElementById('input1').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input2').textContent === 'iita') {
        totalScore++;
        document.getElementById('input2').style.borderColor = '#28C76F';
        document.getElementById('input2').style.backgroundColor = '#28C76F';
      } else {
        document.getElementById('input2').style.borderColor = '#fd4445';
        document.getElementById('input2').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input3').textContent === '') {
        totalScore++;
        document.getElementById('input3').style.borderColor = '#28C76F';
        document.getElementById('input3').style.backgroundColor = '#28C76F';
      } else {
        document.getElementById('input3').style.borderColor = '#fd4445';
        document.getElementById('input3').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input4').textContent === 'snmA') {
        totalScore++;
        document.getElementById('input4').style.borderColor = '#28C76F';
        document.getElementById('input4').style.backgroundColor = '#28C76F';
      } else {
        document.getElementById('input4').style.borderColor = '#fd4445';
        document.getElementById('input4').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input5').textContent === 'inis') {
        totalScore++;
        document.getElementById('input5').style.borderColor = '#28C76F';
        document.getElementById('input5').style.backgroundColor = '#28C76F';
      } else {
        document.getElementById('input5').style.borderColor = '#fd4445';
        document.getElementById('input5').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input6').textContent === 'nist') {
        totalScore++;
        document.getElementById('input6').style.borderColor = '#28C76F';
        document.getElementById('input6').style.backgroundColor = '#28C76F';
      } else {
        document.getElementById('input6').style.borderColor = '#fd4445';
        document.getElementById('input6').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input7').textContent === 'trat') {
        totalScore++;
        document.getElementById('input7').style.borderColor = '#28C76F';
        document.getElementById('input7').style.backgroundColor = '#28C76F';
      } else {
        document.getElementById('input7').style.borderColor = '#fd4445';
        document.getElementById('input7').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input8').textContent === '') {
        totalScore++;
        document.getElementById('input8').style.borderColor = '#28C76F';
        document.getElementById('input8').style.backgroundColor = '#28C76F';
      } else {
        document.getElementById('input8').style.borderColor = '#fd4445';
        document.getElementById('input8').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input9').textContent === 'rota') {
        totalScore++;
        document.getElementById('input9').style.borderColor = '#28C76F';
        document.getElementById('input9').style.backgroundColor = '#28C76F';
      } else {
        document.getElementById('input9').style.borderColor = '#fd4445';
        document.getElementById('input9').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input10').textContent === 'imdA') {
        totalScore++;
        document.getElementById('input10').style.borderColor = '#28C76F';
        document.getElementById('input10').style.backgroundColor = '#28C76F';
      } else {
        document.getElementById('input10').style.borderColor = '#fd4445';
        document.getElementById('input10').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input11').textContent === '') {
        totalScore++;
        document.getElementById('input11').style.borderColor = '#28C76F';
        document.getElementById('input11').style.backgroundColor = '#28C76F';
      } else {
        document.getElementById('input11').style.borderColor = '#fd4445';
        document.getElementById('input11').style.backgroundColor = '#fd4445';
      }
      if (document.getElementById('input12').textContent === '') {
        totalScore++;
        document.getElementById('input12').style.borderColor = '#28C76F';
        document.getElementById('input12').style.backgroundColor = '#28C76F';
      } else {
        document.getElementById('input12').style.borderColor = '#fd4445';
        document.getElementById('input12').style.backgroundColor = '#fd4445';
      }

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    draggable,
    Prism,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>
